import React from 'react';
import { LAYER_CATEGORY_CAPABILITY } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useFetchSpatialLayers from '../../hooks/useFetchSpatialLayers';
import { MapLayersControl } from './MapLayersControl';
import { MapLayersControlWithTabs } from './MapLayersControlWithTabs';

/**
 * Container for Map Layers UI.
 * Fetches spatial layers, then gates on the layer_category capability
 * to render either the tabbed or flat-list version.
 *
 * Once layer_category is enabled for all PSAPs, delete
 * MapLayersControl.js and render MapLayersControlWithTabs directly.
 */
const MapLayersControlContainer = () => {
  const isFetched = useFetchSpatialLayers();
  const { hasCapability } = useHasCapability(LAYER_CATEGORY_CAPABILITY);
  if (!isFetched) {
    return null;
  }

  return hasCapability ? <MapLayersControlWithTabs /> : <MapLayersControl />;
};

export default MapLayersControlContainer;
